// removed by extract-text-webpack-plugin
module.exports = {"muteSwitchContainer":"dbzmV","iconContainer":"_3Cj0q","iconLabel":"VOr3c"};